import New from '../../../api/News';
import * as types from './mutation-types';

export const index = async ({commit, rootState}, payload) => {
    const json = await new New().index({
        ...payload,
        language: rootState.auth.currentLang,
        student: true,
    });

    commit(types.NEWS, json.data);
};

export default {
    index,
};



// WEBPACK FOOTER //
// ./src/store/modules/news/actions.js